/** Every tool code the platform uses: report set-up, the capabilities `tools` list, supported countries. */
export const TOOL_CODES = {
  LSG: 'lsg',
  LRT: 'lrt',
  RM: 'rm',
  CT: 'ct',
  CB: 'cb',
  GBPA: 'gbpa',
  LSA: 'lsa',
  AI_INSIGHTS: 'ai_insights',
  AI_VISIBILITY: 'ai_visibility'
} as const;

/** A tool code */
export type ToolCode = (typeof TOOL_CODES)[keyof typeof TOOL_CODES];

/** Reasons a tool is unavailable for a location */
export const TOOL_UNAVAILABILITY_REASON = {
  COUNTRY_NOT_SUPPORTED: 'country_not_supported',
  CAPABILITY_DISABLED: 'capability_disabled',
  NO_ACTIVE_SUBSCRIPTION: 'no_active_subscription',
  USER_CONTEXT_REQUIRED: 'user_context_required'
} as const;
